module.exports = __webpack_public_path__ + "static/media/lotus-icon.9f43aca9.png";